"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var SettingsFill_exports = {};
__export(SettingsFill_exports, {
  default: () => SettingsFill_default
});
module.exports = __toCommonJS(SettingsFill_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.793 12.125L15.5781 12.6523C15.487 12.8607 15.4609 13.069 15.5 13.2773C15.5521 13.4857 15.6497 13.668 15.793 13.8242C16.0404 14.0586 16.1641 14.3451 16.1641 14.6836C16.1641 15.0221 16.0404 15.3151 15.793 15.5625C15.6758 15.6667 15.5456 15.7513 15.4023 15.8164C15.2591 15.8815 15.1029 15.9141 14.9336 15.9141C14.7773 15.9141 14.6211 15.8815 14.4648 15.8164C14.3216 15.7513 14.1914 15.6667 14.0742 15.5625C13.918 15.4062 13.7357 15.3086 13.5273 15.2695C13.319 15.2174 13.1107 15.237 12.9023 15.3281L12.375 15.543C12.1797 15.6211 12.0234 15.7513 11.9062 15.9336C11.7891 16.1159 11.7305 16.3112 11.7305 16.5195C11.7305 16.8581 11.6068 17.151 11.3594 17.3984C11.125 17.6328 10.8385 17.75 10.5 17.75C10.1615 17.75 9.86849 17.6328 9.62109 17.3984C9.38672 17.151 9.26953 16.8581 9.26953 16.5195C9.26953 16.3112 9.21094 16.1159 9.09375 15.9336C8.97656 15.7513 8.82031 15.6211 8.625 15.543L8.09766 15.3281C8.01953 15.3021 7.94792 15.2826 7.88281 15.2695C7.81771 15.2565 7.7526 15.25 7.6875 15.25C7.54427 15.25 7.40755 15.276 7.27734 15.3281C7.14714 15.3802 7.02995 15.4583 6.92578 15.5625C6.80859 15.6667 6.67188 15.7513 6.51562 15.8164C6.3724 15.8815 6.22266 15.9141 6.06641 15.9141C5.89714 15.9141 5.73438 15.8815 5.57812 15.8164C5.4349 15.7513 5.30469 15.6667 5.1875 15.5625C4.95312 15.3151 4.83594 15.0221 4.83594 14.6836C4.83594 14.3451 4.95312 14.0586 5.1875 13.8242C5.34375 13.668 5.44141 13.4857 5.48047 13.2773C5.53255 13.069 5.51302 12.8607 5.42188 12.6523L5.20703 12.125C5.12891 11.9297 4.9987 11.7734 4.81641 11.6562C4.63411 11.5391 4.4388 11.4805 4.23047 11.4805C3.89193 11.4805 3.59896 11.3633 3.35156 11.1289C3.11719 10.8815 3 10.5885 3 10.25C3 9.91146 3.11719 9.625 3.35156 9.39062C3.59896 9.14323 3.89193 9.01953 4.23047 9.01953C4.4388 9.01953 4.63411 8.96094 4.81641 8.84375C4.9987 8.72656 5.12891 8.57031 5.20703 8.375L5.42188 7.84766C5.51302 7.63932 5.53255 7.43099 5.48047 7.22266C5.44141 7.01432 5.34375 6.83203 5.1875 6.67578C4.95312 6.44141 4.83594 6.15495 4.83594 5.81641C4.83594 5.47786 4.95312 5.1849 5.1875 4.9375C5.4349 4.70312 5.72786 4.58594 6.06641 4.58594C6.40495 4.58594 6.69141 4.70312 6.92578 4.9375C7.08203 5.09375 7.26432 5.19792 7.47266 5.25C7.68099 5.28906 7.88932 5.26302 8.09766 5.17188L8.625 4.95703C8.82031 4.87891 8.97656 4.7487 9.09375 4.56641C9.21094 4.38411 9.26953 4.1888 9.26953 3.98047C9.26953 3.64193 9.38672 3.35547 9.62109 3.12109C9.86849 2.8737 10.1615 2.75 10.5 2.75C10.8385 2.75 11.125 2.8737 11.3594 3.12109C11.6068 3.35547 11.7305 3.64193 11.7305 3.98047C11.7305 4.1888 11.7891 4.38411 11.9062 4.56641C12.0234 4.7487 12.1797 4.87891 12.375 4.95703L12.9023 5.17188C13.1107 5.26302 13.319 5.28906 13.5273 5.25C13.7357 5.19792 13.918 5.09375 14.0742 4.9375C14.3086 4.70312 14.5951 4.58594 14.9336 4.58594C15.2721 4.58594 15.5651 4.70312 15.8125 4.9375C16.0469 5.1849 16.1641 5.47786 16.1641 5.81641C16.1641 6.15495 16.0469 6.44141 15.8125 6.67578C15.6562 6.83203 15.5521 7.01432 15.5 7.22266C15.4609 7.43099 15.487 7.63932 15.5781 7.84766L15.793 8.375C15.8711 8.57031 16.0013 8.72656 16.1836 8.84375C16.3659 8.96094 16.5612 9.01953 16.7695 9.01953C17.1081 9.01953 17.3945 9.14323 17.6289 9.39062C17.8763 9.625 18 9.91146 18 10.25C18 10.5885 17.8763 10.8815 17.6289 11.1289C17.3945 11.3633 17.1081 11.4805 16.7695 11.4805C16.5612 11.4805 16.3659 11.5391 16.1836 11.6562C16.0013 11.7734 15.8711 11.9297 15.793 12.125ZM10.5 13.0625C11.2812 13.0625 11.9453 12.7891 12.4922 12.2422C13.0391 11.6953 13.3125 11.0312 13.3125 10.25C13.3125 9.46875 13.0391 8.80469 12.4922 8.25781C11.9453 7.71094 11.2812 7.4375 10.5 7.4375C9.71875 7.4375 9.05469 7.71094 8.50781 8.25781C7.96094 8.80469 7.6875 9.46875 7.6875 10.25C7.6875 11.0312 7.96094 11.6953 8.50781 12.2422C9.05469 12.7891 9.71875 13.0625 10.5 13.0625Z",
      fill: "currentColor"
    }
  )
);
const SvgSettingsFill = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var SettingsFill_default = SvgSettingsFill;
